export class NonRetryableError extends Error {}
